import { render } from "./giftClaim.vue?vue&type=template&id=75655246&scoped=true"
import script from "./giftClaim.vue?vue&type=script&lang=js"
export * from "./giftClaim.vue?vue&type=script&lang=js"

import "./giftClaim.vue?vue&type=style&index=0&id=75655246&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75655246"]])

export default __exports__